import React, { FC } from 'react';

import { Box } from '@rover/kibble/core';

type Props = {
  title: string;
  children: React.ReactNode;
};

const OptionLabel: FC<Props> = ({ title, children }) => {
  return (
    <Box
      flex="1"
      webAsProps={{
        title, // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/title
      }}
      sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
    >
      {children}
    </Box>
  );
};

export default OptionLabel;
